/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Not_OpenInputs */

const en_po_issue_not_open = /** @type {(inputs: Po_Issue_Not_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is not open`)
};

/**
* | output |
* | --- |
* | "is not open" |
*
* @param {Po_Issue_Not_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_not_open = /** @type {((inputs?: Po_Issue_Not_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Not_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_not_open(inputs)
});